import type { EntityAdminRecord } from '@src/components/EntityAdmin/types';
import { ToggleHorizontal } from '@src/components/Form/ToggleHorizontal';
import { get } from 'lodash-es';
import type { ToggleHorizontalDrawerOption } from '../types';

export function ToggleHorizontalContent<TDrawerRecord extends EntityAdminRecord>({
  drawerOption,
  form,
  isEditing,
  onFormUpdate,
}: {
  drawerOption: ToggleHorizontalDrawerOption<TDrawerRecord>;
  form: TDrawerRecord;
  isEditing: boolean;
  onFormUpdate: (field: keyof TDrawerRecord, value: string | boolean, suppressTouch?: boolean) => void;
}) {
  return (
    <ToggleHorizontal
      value={get(form, drawerOption.field) as string | undefined}
      defaultValue={drawerOption.defaultValue}
      onChange={value => {
        onFormUpdate(drawerOption.field, value);
        drawerOption.onChange?.(value, onFormUpdate, form);
      }}
      disabled={(drawerOption.disabledWhenEditing && isEditing) || drawerOption.getIsDisabled?.(form)}
      options={drawerOption.getToggleOptions(form, isEditing)}
      data-testid={`entity-admin-drawer-${String(drawerOption.field)}`}
      boxProps={{ w: '100%' }}
    />
  );
}
